import { render, staticRenderFns } from "./TaxaEvasao.vue?vue&type=template&id=196aab94&scoped=true"
import script from "./TaxaEvasao.vue?vue&type=script&lang=js"
export * from "./TaxaEvasao.vue?vue&type=script&lang=js"
import style0 from "./TaxaEvasao.vue?vue&type=style&index=0&id=196aab94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196aab94",
  null
  
)

export default component.exports